/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var Backbone = require('backbone');

var GetAllBondCompanies = require('../services/GetAllBondCompanies');
var GetLicenseContactTypes = require('../services/GetLicenseContactTypes');
var GetCollectorRepossessorApplication = require('../services/GetCollectorRepossessorApplication');
var GetLicenseContactTypesByApplicationType = require('../services/GetLicenseContactTypesByApplicationType');
var GetLicenseContactsAndOfficersByEntity = require('../../common/services/GetLicenseContactsAndOfficersByEntity');
var CollectorRepossessorLicenseApplication = require('../forms/CollectorRepossessorLicenseApplication');
var GetApplicationDBAs = require('../services/GetApplicationDBAs');

module.exports = {
  event: 'build:license-new:collector-repossessor',

  channel: 'nd:application',

  builder: function(config) {
    var defer = $.Deferred();
    $.when(
      GetAllBondCompanies(),
      GetLicenseContactTypes(),
      GetCollectorRepossessorApplication(config.applicationId),
      GetLicenseContactTypesByApplicationType(config.applicationTypeId),
      GetLicenseContactsAndOfficersByEntity(config.entityId),
      GetApplicationDBAs(config.applicationId)
    ).done(function(bondCompanies, licenseContactTypes, applicationContent, requiredLicenseContactTypes, existingContacts, dbas) {
      var collectorRepossessorApplicationView = new CollectorRepossessorLicenseApplication({
        isReadOnly: config.isReadOnly,
        mode: config.mode || 'new', // new, resubmit, print or int-expand
        identoGoLink: config.identoGoLink,
        model: new Backbone.Model({
          bondCompanies: bondCompanies,
          applicationId: config.applicationId,
          licenseContactTypes: licenseContactTypes,
          existingContacts: existingContacts,
          applicationContent: applicationContent,
          requiredLicenseContactTypes: requiredLicenseContactTypes,
          entityDBAs: dbas.entityDBAs,
          applicationDBAs: dbas.appDBAs
        })
      });
      defer.resolve(collectorRepossessorApplicationView);
    });
    return defer.promise();
  }
};
